/**
 * Extracts numeric ID from Shopify GID format.
 *
 */
export const getIdFromShopifyGid = (gid: string): number => {
  return Number(
    gid.replace(/^gid:\/\/shopify\/(?:Product|ProductVariant)\//, ''),
  )
}
